/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import type { ReactNode } from 'react';
import {
  Outlet,
  createRootRoute,
  Scripts
} from '@tanstack/react-router';
import { Provider } from 'react-redux'
import { store } from '@/lib/datastore/store'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';


export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <RootDocument>
      <Outlet/>
    </RootDocument>
  ) 
}

function RootDocument({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <Provider store={store}>
      <div className={"clearSans h-full flex flex-row flex-1 items-start justify-between"}>
        {children}
        <Scripts />
      </div>
    </Provider>
  )
}